import { Component, OnDestroy, OnInit } from '@angular/core';
import { TimeCardService } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Router } from '@angular/router';
import { Subscription, timer } from 'rxjs';
import moment from 'moment/moment';

@Component({
  selector: 'app-timesheets-page',
  templateUrl: './timesheets-page.component.html',
  styleUrls: ['./timesheets-page.component.scss'],
  providers: [DeviceDetectorService]
})
export class TimesheetsPageComponent implements OnInit, OnDestroy {

  isMobile: boolean;
  vacationCounter: number;
  vacationCounterSubj: Subscription

  constructor(
    public router: Router,
    private timeCardService: TimeCardService,
    protected deviceDetector: DeviceDetectorService,
  ) {
  }

  ngOnInit() {
    this.isMobile = this.deviceDetector.isMobile();
    this.vacationCounterSubj = this.timeCardService.vacationCounterSubj.subscribe(counter => {
      this.getVacationCounter()
    })
    this.timeCardService.vacationCounterSubj.next()
  }

  getVacationCounter() {
    this.timeCardService.getVacationCounter(
      moment().startOf('year').format('YYYY-MM-DD'),
      moment().endOf('year').format('YYYY-MM-DD'))
    .subscribe(counter => {
      this.vacationCounter = counter
    })
  }

  ngOnDestroy() {
    this.vacationCounterSubj.unsubscribe()
  }

}
